import {
  LitElement,
  html,
  css,
  unsafeHTML,
  utils,
  paths,
  t,
  broadcastReceiver,
} from '@hh/global.js'

class HHNewsletterForm extends LitElement {
  static properties = {
    id: {},
    open: {
      reflect: true,
    },
  }

  constructor() {
    super()

    this.onSubmitHandler = this.onSubmitHandler.bind(this)
  }

  requestUpdate(name, oldValue) {
    if (name === 'error' && !!this[name]) {
      utils.pauseAllMedia()
    }

    return super.requestUpdate(name, oldValue)
  }

  connectedCallback() {
    super.connectedCallback()

    this.form = this.querySelector('form')
    this.submitBtn = this.form.querySelector('button')
    this.input = this.form.querySelector('#newsletter-form-input')
    this.submitBtn.addEventListener('click', this.onSubmitHandler)
    this.input.addEventListener('keydown', (e) => {
      if (e.key === "Enter") {
        this.onSubmitHandler(e)
      }
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.form.removeEventListener('submit', this.onSubmitHandler)
  }

  onSubmitHandler(event) {
    event.preventDefault()
    this.validateInputs()
  }

  removeError() {
    if (!this.inputWrapper.querySelector('.error')) return
    this.inputWrapper = this.form.querySelector('hh-input-wrapper')
    this.inputWrapper.removeChild(this.inputWrapper.querySelector('.error'))
    this.inputWrapper.removeChild(this.inputWrapper.querySelector('[slot="error-icon"]'))
  }

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  validateInputs() {
    this.checkbox = this.form.querySelector('#newsletter-form-checkbox')
    this.input = this.form.querySelector('#newsletter-form-input')
    this.inputWrapper = this.form.querySelector('hh-input-wrapper')

    this.removeError()

    const errorContent = this.form.querySelector('.error-content')?.cloneNode(true)

    if (!this.input.value) {
      errorContent.querySelector('.error').innerText = this.dataset.inputEmpty
      errorContent.querySelector('.error').setAttribute('role', 'alert')
      this.inputWrapper.insertAdjacentHTML('beforeend', errorContent.innerHTML)
      this.inputWrapper.setAttribute('error', 'true')
      return
    }

    if (!this.validateEmail(this.input.value)) {
      errorContent.querySelector('.error').innerText = this.dataset.emailError
      errorContent.querySelector('.error').setAttribute('role', 'alert')
      this.inputWrapper.insertAdjacentHTML('beforeend', errorContent.innerHTML)
      this.inputWrapper.setAttribute('error', 'true')
      return
    }

    if (!this.checkbox.checked) {
      errorContent.querySelector('.error').innerText = this.dataset.checkboxError
      errorContent.querySelector('.error').setAttribute('role', 'alert')
      this.inputWrapper.insertAdjacentHTML('beforeend', errorContent.innerHTML)
      this.inputWrapper.setAttribute('error', 'true')
      return
    }

    this.form.submit()
  }

  render() {
    return html`<slot></slot>`
  }

}

customElements.define('hh-newsletter-form', HHNewsletterForm)
